import { useEffect } from "react";
import { useSite } from "@/context/SiteContext";

/**
 * Applies the admin-configured favicon (settings.favicon_url) at runtime by
 * swapping the document's <link rel="icon"> tags. Falls back to the static
 * /favicon.ico bundled in index.html when no custom favicon is set.
 * Also keeps the browser tab title in sync with the brand name.
 */
export const Favicon = () => {
  const { settings } = useSite();

  useEffect(() => {
    if (!settings) return undefined;

    const url = (settings.favicon_url || "").trim();
    const added = [];

    if (url) {
      // Remove existing icon links so ours take effect (incl. cache-busting).
      document.querySelectorAll("link[rel~='icon'], link[rel='apple-touch-icon']").forEach((el) => el.remove());
      [
        { rel: "icon", href: url },
        { rel: "apple-touch-icon", href: url },
      ].forEach(({ rel, href }) => {
        const link = document.createElement("link");
        link.rel = rel;
        link.href = href;
        document.head.appendChild(link);
        added.push(link);
      });
    }

    if (settings.brand_name) {
      document.title = settings.brand_name;
    }

    return () => { added.forEach((el) => el.remove()); };
  }, [settings]);

  return null;
};
